module.exports = __webpack_public_path__ + "img/gqpjd.2654ebcc.jpg";